import React from 'react'

export default function dashboard() {
	return (
		<div>
			<h2>Dash</h2>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/pages/dashboard.js